export const STUDENT_PROGRESS_WIDGET = {
  StudentProgressBarWidget: 'StudentProgressBarWidget',
  StudentProgressSummaryChartWidget: 'StudentProgressSummaryChartWidget',
  StudentProgressTrophiesWidget: 'StudentProgressTrophiesWidget',
  StudentProgressWeeklyPerformanceChartWidget: 'StudentProgressWeeklyPerformanceChartWidget'
};
